// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackPageView } from "@/lib/analytics"

/**
 * Hands the Meta Pixel a PageView on first load and on every route change (SPA navigation does not reload the
 * page, so the pixel's own load-time PageView would only ever count the entry page). Renders nothing; whether
 * anything is actually sent is decided by trackPageView, behind the Marketing consent (lib/analytics.ts).
 */
export function RouteTracker() {
  const { pathname } = useLocation()
  useEffect(() => {
    trackPageView(pathname)
  }, [pathname])
  return null
}
